import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-themes-page',
    templateUrl: './themes-page.component.html',
    styleUrls: ['./themes-page.component.scss']
})
export class ThemesPageComponent implements OnInit {

    public colors = [
        {bg: 'gray-light', theme: 'light'},
        {bg: 'magenta', theme: 'dark'}
    ];

    public selectedColor = this.colors[0];

    constructor() {
    }

    ngOnInit() {
    }
}
